import { NgModule, NO_ERRORS_SCHEMA, ModuleWithProviders } from '@angular/core';
import { FooterComponent } from './footer.component';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { BreakpointService } from 'src/app/core/services/breakpoints.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';
import { FooterService } from 'src/app/core/services/footer.service';

@NgModule({
  declarations: [FooterComponent],
  imports: [
    CommonModule,
    MatExpansionModule,
    MatDividerModule,
    FlexLayoutModule,
    RouterModule
  ],
  exports: [FooterComponent],
  providers: [BreakpointService, FooterService],
  // bootstrap: [FooterComponent]
})
export class FooterModule {
}